import { createRef, Fragment, useEffect, useState } from "react";
import { Button, Card, Col, Form, Modal, Row, Spinner } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import SearchableSelect from "../common/SearchableSelect";

import {
	update,
	updateCargasList,
	updateProdutosList,
} from "../../redux/slicers/user";
import { clearPersistData } from "../../redux/storeConfig/store";
import {
	apenasNumeros,
	cpf_mask,
	getAllData,
	getCorretData,
	getData,
	getStatusCarga,
	getStatusCargaList,
	numerosDecimal,
	numerosDecimal3,
	numerosEditadoBR,
	updateTableNew,
	valorMoeda,
	verificaTipoUsuario,
} from "../../services/Servicos";
import Loading from "../loading/Loading";

import "./Modal.scss";
import ModalEditarDimensaoProdutosCargas from "./ModalEditarDimensaoProdutosCargas";
import ModalCalculadora from "./ModalCalculadora";
import ModalErrorPretty from "./ModalErrorPretty";
import { getErrorMessage, isSuporte, telefoneMask } from "../../services/helpers";

const nomeD = createRef(null);
const observacaoD = createRef(null);
const statusD = createRef(null);
const caminhaoD = createRef(null);
const rotaD = createRef(null);
const observacaoDelete = createRef(null);
const tipoCaminhaoD = createRef(null);

export default function ModalAtualizarCargas({
	msg,
	title,
	show,
	setShow,
	msgButton,
}) {
	const dispatch = useDispatch();
	const user = useSelector((state) => state.userSlice);
	const caminhoes = useSelector((state) => state.userSlice.caminhoesList);
	const caminhoesFrete = useSelector((state) => state.userSlice.freteiroList);
	const caminhoesSelect = (placa) => caminhoes.data.find((item) => item.placa === placa);
	const caminhoesFreteSelect = (placa) => caminhoesFrete.data.find((item) => item.placa === placa);
	const rotas = useSelector((state) => state.userSlice.rotasList);
	const rotasSelect = useSelector((state) => state.userSlice.rotasList.data);
	const produtosList = useSelector((state) => state.userSlice.produtosList.data);
	const [caminhoesCaminhoneiro, setCaminhoesCaminhoneiro] = useState([])
	const [motoristaSelecionado, setMotoristaSelecionado] = useState({})

	const cidades = (rota) =>
		rotasSelect
			.filter((item) => item.rota === rota)
			.map((item) => item.cidade)
			.filter((i, n, s) => s.indexOf(i) === n)
			.join(", ");

	const [produtoList, setProdutoList] = useState([]);
	const [carga, setCarga] = useState({...msg.body});
	const [pesoTotal, setPesoTotal] = useState(0);
	const [caminhaoSelected, setCaminhaoSelected] = useState(
		msg.body.caminhao
			? caminhoesSelect(msg.body.caminhao) ||
					caminhoesFreteSelect(msg.body.caminhao)
			: {}
	);

	const [loading, setLoading] = useState({
		isLoading: false,
		msg: msgButton,
		style: "primary",
	});

	const [loadingClose, setLoadingClose] = useState({
		isLoading: false,
		msg: msgButton,
		style: "primary",
	});

	// #editar na producao para msg[12]
	
	const [caminhoesAdd, setCaminhoesAdd] = useState(
		msg.body.caminhao ? msg.body.caminhao.split(",") : []
	);

	const [error, setError] = useState({
		show: false,
		message: "",
	});

	// Local state for SearchableSelect
	const [caminhaoValue, setCaminhaoValue] = useState("");
	const [rotaValue, setRotaValue] = useState("");
	const [regiaoEntregaValue, setRegiaoEntregaValue] = useState("");

	const updateCargas = async () => {
		let id_filial = user.tipo !== "empresa" && user.id_filial != 2 ? user.id_filial : "";

		if (user.id_filial == 2) {
			id_filial = "";
		}

		const cargasL = await getAllData( "cargas/em-processamento",{ id_filial, logica: "lte", status: 12 });
			// setCargas(cargasL.data)
		dispatch(updateCargasList(cargasL.data));
		setLoading(false)
		handlerSimpleClose();
	};

	const submitDataExclude = () => {
		setLoading({
			isLoading: true,
			msg: "Excluindo Carga",
			style: "danger",
		});
		msg.msg.motivo = observacaoDelete.current.value.length
			? observacaoDelete.current.value
			: "MOTIVO NÃO RELATADO";
		msg.msg.data_cancelamento = new Date().toISOString();
		msg.msg.status = 0;
		updateTableNew(`cargas?id=${carga.id}`, msg.msg)
			.then((resp) => {
				setLoading({
					isLoading: false,
					msg: "Excluido com Sucesso",
					style: "success",
				});

				updateCargas();
			})
			.catch((error) => {
				if (error.msg === "Unauthorized") {
					alert("Session has Expired");
					dispatch(update({ authenticated: false, token: "" }));
					window.location.replace("/login");
				}
			});
	};

	const submitDataEdit = async () => {
		setLoading({
			isLoading: true,
			msg: "Atualizando Carga",
			style: "warning",
		});

		let cargaToUpdate = {
			nome: carga.nome, 
			observacao: carga.observacao, 
			status: carga.status == 23 ? (carga.regiao_entrega == "LOCAL" ? 15 : 13) : carga.status,
			tipo_carga: carga.tipo_carga, 
			caminhao: caminhoesAdd.join(","),
			caminhoneiro: tipoCaminhaoD.current.value == "Freteiro" ? caminhaoSelected.motorista_cpf : (tipoCaminhaoD.current.value != "" ? motoristaSelecionado?.cpf_caminhoneiro : carga.caminhoneiro),
			rota: carga.rota, 
			regiao_entrega: carga.regiao_entrega, 
			tipo_transporte: tipoCaminhaoD.current.value == "Freteiro" ? "FRETE" : (tipoCaminhaoD.current.value != "" ? "PRÓPRIO" : carga.tipo_transporte),
			qtde_pedidos: carga.qtde_pedidos,
			qtde_produtos: carga.qtde_produtos,
			peso_total: carga.peso_total,
			volume_total: carga.volume_total,
			id_filial: carga.id_filial,
		};

		if(carga.is_finalizado_suporte) {
			cargaToUpdate.is_finalizado_suporte = true;
		}

		const caminhoneiro = caminhoesCaminhoneiro.find(i => i.caminhao_placa === cargaToUpdate.caminhao);

		//caso o status seja menor que 11 (disponivel para entrega)
		if (caminhoneiro && cargaToUpdate.status < 11) {
			cargaToUpdate.caminhoneiro = caminhoneiro?.cpf_caminhoneiro ?? "";
		}
		if (cargaToUpdate.status == "11") {
			cargaToUpdate.data_chegada = null;
			cargaToUpdate.data_inicio_entrega = null;
		}
		
		// caso nos coloquemos de forma manual a carga como entregue, setar a data de chegada do usuario
		// importante para o relatorio dos motoristas
		if (cargaToUpdate.status >= 13) {
			cargaToUpdate.data_chegada = new Date().toISOString();
		}
		
		updateTableNew(`cargas?id=${carga.id}`, { ...cargaToUpdate})
			.then((resp) => {
				setLoading({
					isLoading: false,
					msg: "Atualizado com Sucesso",
					style: "success",
				});

				updateCargas();
			})
			.catch((error) => {
				// let msg = null
				if (error.msg.toLowerCase() === "unauthorized") {
					clearPersistData();
					// dispatch(update({ authenticated: false, token: '', foto_cnh: ''}))
					window.location.replace("/login");
				} else if (error.msg) {
					setError({show: true, message: error.message});
				}

				setLoading({
					isLoading: false,
					msg: msgButton,
					style: "danger",
				});
			});
	};

	const onChangeInput = (e) => {
		e.preventDefault();

		if (caminhaoD.current.value.length) {
			if (tipoCaminhaoD.current?.value != "Freteiro") {
				setCaminhaoSelected(caminhoesSelect(caminhaoD.current.value));
			} else {
				setCaminhaoSelected(caminhoesFreteSelect(caminhaoD.current.value));
			}
		}
		if (e.target.name === "tipoCaminhao") {
			caminhaoD.current.value = "";
			setCaminhaoValue("");
			setCaminhaoSelected({});
		}
		if (e.target.name === "tipo_carga") {
			setCarga((last) => ({ ...last, [e.target.name]: e.target.value }));
			return;
		}
		if (e.target.name === "regiao_entrega") {
			setCarga((last) => ({ ...last, [e.target.name]: e.target.value }));
			return;
		}
		if (e.target.name == "status" && e.target.value == "23") {
			setCarga((last) => ({
				...last,
				status: 23,
				is_finalizado_suporte: true,
				data_chegada: new Date().toISOString(),
			}));
			return;
		}
		if (e.target.name == "status" && e.target.value == "24") {
			setCarga((last) => ({
				...last,
				status: 24,
				data_chegada: new Date().toISOString(),
			}));
			return;
		}
		if(e.target.name == 'nome'){
			setCarga((last) => ({
				...last,
				nome: e.target.value.toUpperCase()
			}));
			return
		}

		setCarga((last) => ({
			...last,
			observacao: observacaoD.current.value.toUpperCase(),
			status: statusD.current.value,
			rota: rotaD.current.value,
		}));
	};

	// Handler for SearchableSelect caminhao
	const handleCaminhaoChange = (e) => {
		const value = e.target.value;
		setCaminhaoValue(value);
		
		// Update the ref to maintain compatibility with existing logic
		if (caminhaoD.current) {
			caminhaoD.current.value = value;
		}
		
		// Update caminhao selection logic
		if (value.length) {
			if (tipoCaminhaoD.current?.value != "Freteiro") {
				setCaminhaoSelected(caminhoesSelect(value));
			} else {
				setCaminhaoSelected(caminhoesFreteSelect(value));
			}
		} else {
			setCaminhaoSelected({});
		}
	};

	// Handler for SearchableSelect rota
	const handleRotaChange = (e) => {
		const value = e.target.value;
		setRotaValue(value);
		
		// Update the ref to maintain compatibility with existing logic
		if (rotaD.current) {
			rotaD.current.value = value;
		}
		
		// Update carga state
		setCarga(prev => ({
			...prev,
			rota: value
		}));
	};

	// Handler for SearchableSelect regiao_entrega
	const handleRegiaoEntregaChange = (e) => {
		const value = e.target.value;
		setRegiaoEntregaValue(value);
		
		// Update carga state
		setCarga(prev => ({
			...prev,
			regiao_entrega: value
		}));
	};

	const addCaminhaoToCarga = (e) => {
		e.preventDefault();
		const caminhaoSelected = caminhaoValue || caminhaoD.current?.value;

		if (caminhoesAdd.length == 1) return setError({show: true, message: "Não é possivel ter mais de um caminhão para uma CARGA!"});
		if (carga.qtde_pedidos == 0) return setError({ show: true, children: <i style={{ fontSize: "1.2rem" }}>"Carga sem Pedidos! Adicione <b>pedidos</b> a carga para poder selecionar caminhões..."</i> })
		
		let dadosCaminhao
		
		if (tipoCaminhaoD.current.value == 'Freteiro') {
			dadosCaminhao = caminhoesFreteSelect(caminhaoSelected)

		} else {
			dadosCaminhao = caminhoesSelect(caminhaoSelected)
			const produtoExcedente = produtoList.find(produto => produto.comprimento > dadosCaminhao.comprimento)
			

			//regra de negocio para comparação de medidas
			if (produtoExcedente) return setError({
				show: true,
				children:
				<i style={{ fontSize: "1.2rem" }}>Produto <b style={{ fontSize: "1rem" }}>"{produtoExcedente.descricao}"</b> com comprimento de <b style={{ fontSize: "1rem" }}>"{produtoExcedente.comprimento}[m]"</b> excede o <b>COMPRIMENTO MÁXIMO</b> do caminhão de <b style={{ fontSize: "1rem" }}>"{dadosCaminhao.comprimento}[m]"</b></i>
			})

			//regra de negocio para comparação de peso
			const {pbt, tara} = dadosCaminhao
			if(pesoTotal > (pbt - tara) * 1000) return setError({
				show: true,
				children:
					<i style={{ fontSize: "1.2rem" }}>Peso total da carga
						<b style={{ fontSize: "1rem" }}>"{numerosEditadoBR(pesoTotal)}"</b>
						excede o peso limite do caminhão
						<b style={{ fontSize: "1rem" }}>"{numerosEditadoBR((pbt - tara) * 1000)}[kg]"</b>
						<br></br>
						<br></br>
						Calculo: PBT - Tara {">="} Peso da Carga
				
					</i>
			})
		}

			

		if (caminhoesAdd.indexOf(caminhaoSelected) < 0 && caminhaoSelected.length) {
			setCaminhoesAdd((last) => [...last, caminhaoSelected]);
			const caminhaoCaminhoneiroSelected = caminhoesCaminhoneiro.find(i => i.caminhao_placa == caminhaoSelected)
			if (tipoCaminhaoD.current.value == 'Freteiro'){
				setMotoristaSelecionado({...dadosCaminhao, cpf_caminhoneiro: dadosCaminhao.motorista_cpf, nome_caminhoneiro: dadosCaminhao.motorista_nome})
			}else{
				if(caminhaoCaminhoneiroSelected){
					setMotoristaSelecionado(caminhaoCaminhoneiroSelected)
				}else{
					setError({show: true, message: "Caminhão selecionado está sem motorista!."});
				}
			}
		} else if (!caminhaoSelected.length) {
			return setError({show: true, message: "Selecione um caminhão."});
		} else {
			return setError({show: true, message: "Caminhão já selecionado. Tente outro caminhão"});
		}
		caminhaoD.current.value = "";
		setCaminhaoValue("");
	};

	const onClickRemoveFilter = (e) => {
		if(msg.body.status > 1){
			return setError({show: true, children: <div style={{whiteSpace:`wrap`}}>Impossível remover o caminhao. Status da carga é <b>{getStatusCarga(msg.body.status)}</b>! Volter a carga para o status <b>{getStatusCarga(0)}</b> para prosseguir com a alteração.</div>});
		}
		e.preventDefault();
		const value = e.target.parentNode.firstElementChild.innerText;
		setCaminhoesAdd((last) => [...last.filter((item) => item !== value)]);
		setMotoristaSelecionado({})
	};

	const handlerSimpleClose = async () => {
		setShow((last) => ({ error: { flag: false } }));
	};

	const updateArrayEmbalagens = async (carga_id) => {
		try {
			let embalagens;
			if (user.tipo.toLowerCase() == "empresa") {
				embalagens = await getAllData(`embalagens/empresa/${carga_id}`);
			} else {
				embalagens = await getAllData("cargas/funcionarios/embalagens", {
					cargas_id: carga_id,
				});
			}

			return embalagens.data;
		} catch (error) {
			
			return setError({show: true, message: "Erro na obtenção das embalagens existentes"});
		}
	};

	const updateArrayProdutos = async (carga_id) => {
		try {
			const produtosGet = await getData(
				verificaTipoUsuario(user) + "planejamento/cargas/get-produtos",
				carga_id
			);
			return produtosGet.data;
		} catch (error) {
			
			return setError({show: true, message: "Erro na obtenção dos produtos"});
		}
	};

	const getMaiorProduto = async (carga_id) => {
		/**
		 * pegar todos os produtos da carga, com apenas o campo de descrição do produto e comprimento do produto
		 */
		const [produtosL, embalagensL] = await Promise.all([
			updateArrayProdutos(carga_id),
			updateArrayEmbalagens(carga_id),
		]);
		const produtosH = [...produtosL.filter((item) => !item.embalado)].map(
			(item) => ({ ...item, tipo: "PRODUTO" })
		);
		const embalagemsH = [...embalagensL].map((item) => ({
			...item,
			tipo: "EMBALAGEM",
			descricao: item.descricao.length
				? item.descricao
				: `EMBALAGEM N°${String(item.numero_embalagem).padStart(0, 6)}`,
			qtde: item.qtde_produtos,
		}));
		const result = [
			...produtosH.filter((item) => !item.embalado),
			...embalagemsH,
		];

		// const produtosGet =  await getData(verificaTipoUsuario(user) + 'planejamento/cargas/get-produtos', carga_id, {})
		const produto = result.sort((a, b) => {
			if (a.comprimento > b.comprimento) return -1;
			if (a.comprimento < b.comprimento) return 1;
			return 0;
		});

		const pesoTotal = result.reduce((p, c) => p + c.peso, 0);
		setProdutoList(result)

		dispatch(updateProdutosList(result));
		setPesoTotal(pesoTotal);
	};

	const getTrucks = async () => { 
		// getAllData('/caminhoes/caminhoneiros'),
		try {
			const [caminhoesCaminhoneiros] = await Promise.all([
				getAllData('caminhoes/caminhoneiros'),
			])
			setCaminhoesCaminhoneiro(caminhoesCaminhoneiros.data.filter(i => i.cpf_caminhoneiro))
			if(carga.caminhao){
				setMotoristaSelecionado(caminhoesCaminhoneiros.data.find(i => i.caminhao_placa == carga.caminhao))
			}
		} catch (error) {
			setError({show: true, message: getErrorMessage(error)})
		}
	}

	useEffect(() => {
		getTrucks()
		getMaiorProduto(msg.msg.pk);
	}, []);

	// Sync local state with any initial or updated values
	useEffect(() => {
		if (caminhaoD.current && caminhaoD.current.value !== caminhaoValue) {
			setCaminhaoValue(caminhaoD.current.value);
		}
	}, [caminhaoD.current?.value]);

	// Update ref when local state changes to maintain compatibility
	useEffect(() => {
		if (caminhaoD.current) {
			caminhaoD.current.value = caminhaoValue;
		}
	}, [caminhaoValue]);

	// Initialize and sync rota and regiao_entrega local state values
	useEffect(() => {
		setRotaValue(carga.rota || "");
		setRegiaoEntregaValue(carga.regiao_entrega || "");
	}, [carga.rota, carga.regiao_entrega]);

	// Update rota ref when local state changes
	useEffect(() => {
		if (rotaD.current) {
			rotaD.current.value = rotaValue;
		}
	}, [rotaValue]);

	const [editarRow, setEditarRow] = useState({ show: false, title: "" });
	const onClickEditarRow = (e) => {
		e.preventDefault();
		setEditarRow({ show: true, title: "Editar Carga", row: msg.body });
	};
	const fnRetornoEditRow = async (bodyEdit) => {
		try {
			await updateTableNew(`cargas?id=${carga.id}`, bodyEdit)
		} catch (error) {
			setError({show: true, message: getErrorMessage(error)})
		}
	};

	return (
		<>
			<Modal
				show={show}
				onHide={handlerSimpleClose}
				backdrop="static"
				keyboard={false}
				centered
				size="xl"
			>
				<Modal.Header closeButton>
					<Modal.Title>
						{title}: {msg.msg.pk}
					</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					{title.includes("Excluir") ? <ExcluirDados msg={msg} /> : ""}
					{title.includes("Editar") ? (
						<>
							<Informacoes
								produto={produtosList}
								caminhao={caminhaoSelected}
								pesoTotal={pesoTotal}
								status={carga.status}
							/>
							<Form>
								<Row>
									<Col sm="12" lg="6" xl="8" className="mb-4">
										<Row className="mb-2">
											<Col sm="4">
												<Form.Label>Nome Carga:</Form.Label>
											</Col>
											<Col>
												<Form.Control
													type="text"
													required
													name="nome"
													value={carga.nome}
													onChange={onChangeInput}
												/>
											</Col>
										</Row>
										<Row className="mb-2">
											<Col sm="4">
												<Form.Label>Observação:</Form.Label>
											</Col>
											<Col>
												<Form.Control
													type="text"
													placeholder={carga.observacao}
													required
													value={carga.observacao}
													ref={observacaoD}
													onChange={onChangeInput}
												/>
											</Col>
										</Row>
										<Row className="mb-2">
											<Col sm="4">
												<Form.Label>Status:</Form.Label>
											</Col>
											<Col>
												<Form.Select
													type="text"
													ref={statusD}
													onChange={onChangeInput}
													value={carga.status}
													name="status"
													disabled={
														carga.status <= -2 &&
														caminhaoSelected?.placa == carga.caminhao
													}
												>
													<option value=""></option>
													<option value="0">INDISPONIVEL</option>
													<option value="1">DISPONIVEL PARA SEPARAÇÃO</option>
													<option value="3">DISPONIVEL PLANEJAMENTO</option>
													<option value="5">DISPONIVEL PARA FINANCEIRO</option>
													<option value="9">
														DISPONIVEL PARA CARREGAMENTO
													</option>
													<option value="11">DISPONIVEL PARA ENTREGA</option>
													{carga.tipo_transporte == "FRETE" ||
													carga.tipo_carga == "TRANSFERÊNCIA" ||
													carga.regiao_entrega == "LOCAL" ||
													carga.tipo_carga == "RETORNO" ? (
														<option value="24">FINALIZADO PELO GESTOR</option>
													) : (
														""
													)}
													{isSuporte(user.email) ? ( //id do suporte
														<>
															<option value=""></option>
															<option value="">SUPORTE</option>
															<option value="23">ENTREGUE</option>
															<option value="24">FECHAMENTO FINANCEIRO</option>
														</>
													) : (
														""
													)}
												</Form.Select>
											</Col>
										</Row>
										<Row className="mb-2">
											<Col sm="4">
												<Form.Label>Tipo da Carga:</Form.Label>
											</Col>
											<Col>
												<Form.Select
													type="text"
													onChange={onChangeInput}
													name="tipo_carga"
													value={carga.tipo_carga}
												>
													<option value="PADRÃO">Padrão</option>
													<option value="TRANSFERÊNCIA">Transferência</option>
													<option value="RETORNO">Retorno</option>
												</Form.Select>
											</Col>
										</Row>
										<Row className="mb-2">
											<Col sm="4">
												<Form.Label>Tipo do Caminhão:</Form.Label>
											</Col>
											<Col>
												<Row>
													<Col col="8">
														<Form.Select
															type="text"
															ref={tipoCaminhaoD}
															onChange={onChangeInput}
															name="tipoCaminhao"
														>
															<option value=""></option>
															<option value="Toco">Toco</option>
															<option value="Truck">Truck</option>
															<option value="BiTruck">BiTruck</option>
															<option value="Carreta">Carreta</option>
															<option value="Freteiro">Caminhao Frete</option>
														</Form.Select>
													</Col>
												</Row>
											</Col>
										</Row>
										<Row className="mb-2">
											<Col sm="4">
												<Form.Label>Caminhão:</Form.Label>
											</Col>
											<Col>
												<Row>
													<Col col="8">
														<SearchableSelect
															options={
																tipoCaminhaoD.current?.value != "Freteiro"
																	? caminhoes.data
																			.filter((item) => item.status == 1)
																			.filter((item) => {
																				return (
																					item.tipo.toLowerCase() ===
																					tipoCaminhaoD.current?.value.toLowerCase()
																				);
																			})
																			.map((item) => ({
																				value: item.placa,
																				label: `${item.placa}. P: ${numerosEditadoBR(
																					item?.pbt - item?.tara
																				)} [Ton]; A: ${numerosEditadoBR(item?.altura)} [m]; C: ${numerosEditadoBR(item?.comprimento)} [m]; L: ${numerosEditadoBR(item?.largura)} [m]`
																			}))
																	: caminhoesFrete.data.map((item) => ({
																			value: item.placa,
																			label: `${item.tipo} - ${item.placa} - ${item?.motorista_nome?.slice(0, 15)}...`
																	  }))
															}
															value={caminhaoValue}
															onChange={handleCaminhaoChange}
															placeholder="Selecione um caminhão..."
															searchPlaceholder="Buscar caminhão..."
															maxHeight="300px"
														/>
														{/* Hidden ref input for compatibility */}
														<input type="hidden" ref={caminhaoD} value={caminhaoValue} />
													</Col>
													<Col sm="4">
														<Button onClick={addCaminhaoToCarga}>Add</Button>
													</Col>
												</Row>
											</Col>
										</Row>
										{caminhoesAdd.length ? (
											<Row
												style={{ alignItems: "baseline", marginBottom: "10px" }}
											>
												<Col sm="4">Caminhoes:</Col>
												<Col sm="8">
													<div className="d-flex" style={{ overflow: "auto" }}>
														{caminhoesAdd.map((item, index) => (
															<span className="filters-card" key={index}>
																<span className="filters">
																	<span className="title">{item}</span>
																	<i
																		className="bi bi-x-lg"
																		onClick={onClickRemoveFilter}
																	></i>
																</span>
															</span>
														))}
													</div>
												</Col>
											</Row>
										) : (
											""
										)}
										<Row className="mb-2">
											<Col sm="4">
												<Form.Label>Rota:</Form.Label>
											</Col>
											<Col>
												<SearchableSelect
													options={rotas.data
														.filter(
															(i, n, s) =>
																s.findIndex((o) => o.rota === i.rota) === n
														)
														.map((item) => ({
															value: item.rota,
															label: `${item.rota}: ${cidades(item.rota)}`
														}))}
													value={rotaValue}
													onChange={handleRotaChange}
													placeholder="Selecione uma rota..."
													searchPlaceholder="Buscar rota..."
													maxHeight="250px"
												/>
												{/* Hidden ref input for compatibility */}
												<input type="hidden" ref={rotaD} value={rotaValue} />
											</Col>
										</Row>
										<Row className="mb-2">
											<Col sm="4">
												<Form.Label>Região de Entrega:</Form.Label>
											</Col>
											<Col>
												<SearchableSelect
													options={[
														{ value: "LOCAL", label: "Local" },
														{ value: "REGIONAL", label: "Regional" }
													]}
													value={regiaoEntregaValue}
													onChange={handleRegiaoEntregaChange}
													placeholder="Selecione região..."
													searchPlaceholder="Buscar região..."
													maxHeight="150px"
												/>
											</Col>
										</Row>
									</Col>
									<Col sm="12" lg="6" xl="4">
										<Card
											className="card-dashboard"
											style={{ backgroundColor: "#F7D56C", padding: "10px" }}
										>
											<Card.Title className="text-center">Caminhão</Card.Title>
											<hr />
											<Row className="align-items-center">
												<Col sm="4">Placa:</Col>
												<Col>
													<p style={{ fontSize: "0.75rem", color: "inherit" }}>
														<b>{caminhaoSelected?.placa ?? "Selecione!"}</b>
													</p>
												</Col>
											</Row>
											<Row className="align-items-center">
												<Col sm="4">Dimensões:</Col>
												<Col>
													<p style={{ fontSize: "0.75rem", color: "inherit" }}>
														<b>
															C:{caminhaoSelected?.comprimento ?? 0} [m] | A:
															{caminhaoSelected?.altura ?? 0} [m] | L:
															{caminhaoSelected?.largura ?? 0} [m]
														</b>
													</p>
												</Col>
											</Row>
											<Row className="align-items-center">
												<Col sm="4">Capacidades:</Col>
												<Col>
													<p style={{ fontSize: "0.75rem", color: "inherit" }}>
														<b>
															PBT:
															{caminhaoSelected?.pbt
																? Number(caminhaoSelected?.pbt).toFixed(2)
																: 0.0}{" "}
															[T] | Tara:
															{caminhaoSelected?.tara
																? Number(caminhaoSelected?.tara).toFixed(2)
																: 0.0}{" "}
															[T] | Capac.:
															{caminhaoSelected?.capacidade
																? Number(caminhaoSelected?.capacidade).toFixed(
																		2
																  )
																: 0.0}{" "}
															[T]
														</b>
													</p>
												</Col>
											</Row>

											<hr />
											<p className="mb-1">
												Capacidade Total:{" "}
												{numerosEditadoBR(
													((caminhaoSelected?.pbt || 0) - (caminhaoSelected?.tara || 0)) * 1000
												)}{" "}
												[ kg ]
											</p>
											<p className="mb-1">
												Capacidade Restante:{" "}
												{
													numerosEditadoBR(
														((caminhaoSelected?.pbt || 0) - (caminhaoSelected?.tara || 0)) * 1000 -
															produtosList.reduce((p, c) => p + c.peso, 0)
													)}{" "}
												[ kg ]
											</p>
										</Card>
										<Card
											className="card-dashboard"
											style={{ backgroundColor: "rgb(108, 209, 247)", padding: "10px" }}
										>
											<Card.Title className="text-center">Motorista</Card.Title>
											<hr />
											<Row className="align-items-center">
												<Col sm="4">CPF:</Col>
												<Col>
													<b>{motoristaSelecionado?.cpf_caminhoneiro?? 'Sem Motorista' }</b>
												</Col>
											</Row>
											<Row className="align-items-center">
												<Col sm="4">Nome:</Col>
												<Col>
												{/* <pre>{JSON.stringify(caminhoesCaminhoneiro, null, 2)}</pre> */}
													<b>{motoristaSelecionado?.nome_caminhoneiro ?? 'Sem Motorista' }</b>
												</Col>
											</Row>
										</Card>
									</Col>
								</Row>
							</Form>
						</>
					) : (
						""
					)}
				</Modal.Body>
				<Modal.Footer>
					<Row style={{ width: "100%" }}>
					 { isSuporte(user.email) ? 
						<Col>
							<Button onClick={onClickEditarRow} variant="warning"> Suporte</Button>
						</Col>
					: ""}
						<Col>
							<Button
								variant={loading.style}
								onClick={
									title.includes("Editar") ? submitDataEdit : submitDataExclude
								}
							>
								{loading.isLoading ? (
									<Loading msg={loading.msg} />
								) : (
									loading.msg
								)}
								{loading.style === "success" ? (
									<i className="bi bi-check"></i>
								) : (
									""
								)}
							</Button>
						</Col>
						<Col>
							<Button variant="secondary" onClick={handlerSimpleClose}>
								{loadingClose.isLoading ? (
									<Loading msg={loadingClose.msg} color={"black"} />
								) : (
									"Cancelar"
								)}
							</Button>
						</Col>
					</Row>
				</Modal.Footer>
				{editarRow.show ? (
					<ModalEditarCargaSuporte
						setShow={setEditarRow}
						caminhoesCaminhoneiro={caminhoesCaminhoneiro}
						{...editarRow}
						fnRetorno={fnRetornoEditRow}
					/>
				) : (
					""
				)}
				{error.show ? ( <ModalErrorPretty {...error} setShow={setError} />) : ("")}
			</Modal>
		</>
	);
}

function ExcluirDados({ msg }) {
	return (
		<Fragment>
			<div>
				<Form>
					{Object.keys(msg.msg).map((key, index) => (
						<Row className="align-items-end" key={index}>
							<Col sm="3" className="mb-2">
								<Form.Label>{key.toUpperCase()}:</Form.Label>
							</Col>
							<Col className="mb-2">
								<Form.Control
									className="form-control-input"
									defaultValue={msg.msg[key]}
									disabled
								/>
							</Col>
						</Row>
					))}

					<Row className="align-items-end">
						<Col sm="3" className="mb-2">
							<Form.Label>MOTIVO CANC.:</Form.Label>
						</Col>
						<Col className="mb-2">
							<Form.Control
								required
								name="filterKeyword"
								className="form-control-input"
								placeholder="Digite o motivo do cancelamento"
								ref={observacaoDelete}
							/>
						</Col>
					</Row>
				</Form>
			</div>
		</Fragment>
	);
}

function Informacoes({ produto = [], caminhao, status, motorista }) {
	const [loading, setLoading] = useState(true);
	const [editarModal, setEditarModal] = useState({
		flag: false,
	});
	const [produtoEditado, setProdutoEditado] = useState({
		pedido: 0,
		qr_sku: 0,
		value: {
			old: 0,
			new: 0,
		},
	});
	const [showCalculator, setShowCalculator] = useState({
		flag: false,
		pedido: 0,
		qr_sku: 0,
	});

	const [error, setError] = useState({
		show: false,
		message: ''
	});

	const changeValue = (e, item, dimensao) => {
		if (item.tipo == "EMBALAGEM") {
			return setError({show: true, message: "Edição de Embalagem não habilitada"});
		}

		setProdutoEditado({
			pedido: item.numero_pedido,
			qr_sku: item.qr_sku, //
			value: {
				old: item[dimensao],
				new: numerosDecimal3(apenasNumeros(e.target.value)),
			},
			dimensao,
			cargas_id: item.cargas_id,
			title: "Atualizar " + dimensao.toUpperCase(),
			msg: `Confirmar Atualização de Produto "${
				item.descricao
			}":  Valor Antigo: ${
				produtoEditado.value.old
			} -> Valor Novo: ${numerosDecimal3(apenasNumeros(e.target.value))}`,
		});
	};

	const handleDivBlur = (event) => {
		if (produtoEditado.value.old == produtoEditado.value.new) return;
		setEditarModal({ produtoEditado, flag: true });
	};

	useEffect(() => {
		if (produto.length) setLoading(false);
		setTimeout(() => {
			setLoading(false);
		}, 1000);
	}, [produto]);

	return (
		<div className="card-header mx-2">
			<h3 className="card-header">Informações da Carga</h3>
			<Row>
				<Col sm="12" lg="6" xl="4">
					<Card
						className="card-dashboard"
						style={{ backgroundColor: "#ece7e7", padding: "10px" }}
					>
						<Card.Title className="text-center">Maior Comprimento</Card.Title>
						<hr />
						<Row
							className="align-items-center"
							style={{ borderBottom: "solid 1px black" }}
						>
							<Col sm="2" style={{ fontSize: "0.8rem" }}>
								<b>QTDE</b>
							</Col>
							<Col sm="6" style={{ fontSize: "0.8rem" }}>
								<b>Nome</b>
							</Col>
							<Col sm="4" style={{ fontSize: "0.8rem", textAlign: "center" }}>
								<b>Comprimento [ m ]</b>
							</Col>
						</Row>
						<div
							style={{
								overflow: "hidden",
								overflowY: "auto",
								maxHeight: "200px",
							}}
						>
							{loading ? (
								<Fragment>
									<Row className="align-items-center mt-2">
										<Col sm="2">
											<div style={{ fontSize: "0.75rem", color: "inherit" }}>
												<Spinner animation="border" variant="dark" size="sm" />
											</div>
										</Col>
										<Col sm="6">
											<div style={{ fontSize: "0.75rem", color: "inherit" }}>
												<Spinner animation="border" variant="dark" size="sm" />
											</div>
										</Col>
										<Col sm="4">
											<div
												style={{
													fontSize: "0.75rem",
													color: "inherit",
													textAlign: "center",
												}}
											>
												<Spinner animation="border" variant="dark" size="sm" />
											</div>
										</Col>
									</Row>
								</Fragment>
							) : (
								""
							)}
							{produto.length &&
								[...produto]
									.sort((a, b) => {
										if (a.comprimento > b.comprimento) return 1;
										if (a.comprimento < b.comprimento) return -1;
										return 0;
									})
									.reverse()
									.map((item, key) => {
										return (
											<Fragment key={key}>
												<Row
													className="align-items-center py-1"
													style={{ borderBottom: "solid 1px black" }}
												>
													<Col sm="2">
														{loading ? (
															<div
																style={{
																	fontSize: "0.75rem",
																	color: "inherit",
																}}
															>
																<Spinner
																	animation="border"
																	variant="dark"
																	size="sm"
																/>
															</div>
														) : (
															<p
																style={{
																	fontSize: "0.75rem",
																	color: "inherit",
																	padding: "3px 0px",
																	borderRadius: "4px",
																	marginTop: "5px",
																}}
															>
																<b>{item?.qtde ?? 0}</b>
															</p>
														)}
													</Col>
													<Col sm="6">
														{loading ? (
															<div
																style={{
																	fontSize: "0.75rem",
																	color: "inherit",
																}}
															>
																<Spinner
																	animation="border"
																	variant="dark"
																	size="sm"
																/>
															</div>
														) : (
															<p
																style={{
																	fontSize: "0.75rem",
																	color: "inherit",
																	padding: "3px 0px",
																	borderRadius: "4px",
																	marginTop: "5px",
																}}
															>
																<b>{item?.descricao ?? "Sem Produtos"}</b>
															</p>
														)}
													</Col>
													<Col
														sm="4"
														className="d-flex align-items-center justify-content-center"
													>
														{loading ? (
															<div
																style={{
																	fontSize: "0.75rem",
																	color: "inherit",
																	textAlign: "center",
																}}
															>
																<Spinner
																	animation="border"
																	variant="dark"
																	size="sm"
																/>
															</div>
														) : (
															<input
																placeholder={
																	item.comprimento >= 0
																		? `${item.comprimento}`
																		: "Sem Produtos"
																}
																onChange={(e) =>
																	changeValue(e, item, "comprimento")
																}
																onBlur={(e) => handleDivBlur(e, item)}
																value={
																	produtoEditado.qr_sku === item.qr_sku &&
																	produtoEditado?.dimensao == "comprimento"
																		? produtoEditado.value.new
																		: Number(item.comprimento).toLocaleString(
																				"pt-BR"
																		  )
																}
																// value={ produtoEditado.qr_sku === item.qr_sku && produtoEditado?.dimensao == 'comprimento' ? (!produtoEditado.value.new ? produtoEditado.value.old : produtoEditado.value.new) : Number(item.comprimento).toLocaleString('pt-BR') }
																style={{
																	display: "flex",
																	width: "100px",
																	textAlign: "center",
																	cursor: "pointer",
																}}
																disabled={status === 0 ? false : true} // somente possibilitar edição em planejamento
															/>
														)}
													</Col>
												</Row>
											</Fragment>
										);
									})}
						</div>
					</Card>
				</Col>
				<Col sm="12" lg="6" xl="4">
					<Card
						className="card-dashboard"
						style={{ backgroundColor: "#ece7e7", padding: "10px" }}
					>
						<Card.Title className="text-center">Maior Peso</Card.Title>
						<hr />
						<p
							style={{
								textAlign: "center",
								marginBottom: "20px",
								color: "#000",
								fontWeight: "500",
							}}
						>
							Peso Total:{" "}
							{numerosEditadoBR(produto.reduce((p, c) => p + c.peso, 0))} [kg]
						</p>
						<Row
							className="align-items-center"
							style={{ borderBottom: "solid 1px black" }}
						>
							<Col sm="2" style={{ fontSize: "0.8rem" }}>
								<b>QTDE</b>
							</Col>
							<Col sm="6" style={{ fontSize: "0.8rem" }}>
								<b>Nome</b>
							</Col>
							<Col sm="4" style={{ fontSize: "0.8rem", textAlign: "center" }}>
								<b>Peso [ kg ]</b>
							</Col>
						</Row>
						<div
							style={{
								overflow: "hidden",
								overflowY: "auto",
								maxHeight: "200px",
							}}
						>
							{loading ? (
								<Fragment>
									<Row className="align-items-center mt-2">
										<Col sm="8">
											<div style={{ fontSize: "0.75rem", color: "inherit" }}>
												<Spinner animation="border" variant="dark" size="sm" />
											</div>
										</Col>
										<Col sm="4">
											<div
												style={{
													fontSize: "0.75rem",
													color: "inherit",
													textAlign: "center",
												}}
											>
												<Spinner animation="border" variant="dark" size="sm" />
											</div>
										</Col>
									</Row>
								</Fragment>
							) : (
								""
							)}
							{produto.length &&
								[...produto]
									.sort((a, b) => {
										if (a.peso > b.peso) return -1;
										if (a.peso < b.peso) return 1;
										return 0;
									})
									.map((item, key) => {
										return (
											<Fragment key={key}>
												<Row
													className="align-items-center py-1"
													style={{ borderBottom: "solid 1px black" }}
												>
													<Col sm="2">
														{loading ? (
															<div
																style={{
																	fontSize: "0.75rem",
																	color: "inherit",
																}}
															>
																<Spinner
																	animation="border"
																	variant="dark"
																	size="sm"
																/>
															</div>
														) : (
															<p
																style={{
																	fontSize: "0.75rem",
																	color: "inherit",
																	padding: "3px 0px",
																	borderRadius: "4px",
																	marginTop: "5px",
																}}
															>
																<b>{item?.qtde ?? 0}</b>
															</p>
														)}
													</Col>
													<Col sm="6">
														{loading ? (
															<div
																style={{
																	fontSize: "0.75rem",
																	color: "inherit",
																}}
															>
																<Spinner
																	animation="border"
																	variant="dark"
																	size="sm"
																/>
															</div>
														) : (
															<p
																style={{
																	fontSize: "0.75rem",
																	color: "inherit",
																	padding: "3px 0px",
																	borderRadius: "4px",
																	marginTop: "5px",
																}}
															>
																<b>{item?.descricao ?? "Sem Produtos"}</b>
															</p>
														)}
													</Col>
													<Col sm="4">
														{loading ? (
															<div
																style={{
																	fontSize: "0.75rem",
																	color: "inherit",
																	textAlign: "center",
																}}
															>
																<Spinner
																	animation="border"
																	variant="dark"
																	size="sm"
																/>
															</div>
														) : (
															<input
																placeholder={
																	item.peso >= 0
																		? `${item.peso}`
																		: "Sem Produtos"
																}
																onChange={(e) => changeValue(e, item, "peso")}
																onBlur={(e) => handleDivBlur(e, item)}
																value={
																	produtoEditado.qr_sku === item.qr_sku &&
																	produtoEditado?.dimensao == "peso"
																		? produtoEditado.value.new
																		: Number(item.peso).toLocaleString("pt-BR")
																}
																// value={produtoEditado.qr_sku === item.qr_sku && produtoEditado?.dimensao == 'peso'  ? (!produtoEditado.value.new ? produtoEditado.value.old : produtoEditado.value.new): Number(item.peso).toLocaleString('pt-BR')}
																style={{
																	display: "flex",
																	width: "100px",
																	textAlign: "center",
																	cursor: "pointer",
																}}
																disabled={status === 0 ? false : true} // somente possibilitar edição em planejamento
															/>
														)}
													</Col>
												</Row>
											</Fragment>
										);
									})}
						</div>
					</Card>
				</Col>
				<Col sm="12" lg="6" xl="4">
					<Card
						className="card-dashboard"
						style={{ backgroundColor: "#ece7e7", padding: "10px" }}
					>
						<Card.Title className="text-center">Maior Volume</Card.Title>
						<hr />
						<p
							style={{
								textAlign: "center",
								marginBottom: "20px",
								color: "#000",
								fontWeight: "500",
							}}
						>
							Volume Total:{" "}
							{numerosEditadoBR(
								produto.reduce((p, c) => p + Number(c?.volume) ?? 0, 0)
							)}{" "}
							[ m<sup>3</sup> ]
						</p>
						<Row
							className="align-items-center"
							style={{ borderBottom: "solid 1px black" }}
						>
							<Col sm="2" style={{ fontSize: "0.8rem" }}>
								<b>QTDE</b>
							</Col>
							<Col sm="6" style={{ fontSize: "0.8rem" }}>
								<b>Nome</b>
							</Col>
							<Col sm="4" style={{ fontSize: "0.8rem", textAlign: "center" }}>
								<b>
									Volume [ m<sup>3</sup> ]
								</b>
							</Col>
						</Row>
						<div
							style={{
								overflow: "hidden",
								overflowY: "auto",
								maxHeight: "200px",
							}}
						>
							{loading ? (
								<Fragment>
									<Row className="align-items-center mt-2">
										<Col sm="2">
											<div style={{ fontSize: "0.75rem", color: "inherit" }}>
												<Spinner animation="border" variant="dark" size="sm" />
											</div>
										</Col>
										<Col sm="6">
											<div style={{ fontSize: "0.75rem", color: "inherit" }}>
												<Spinner animation="border" variant="dark" size="sm" />
											</div>
										</Col>
										<Col sm="4">
											<div
												style={{
													fontSize: "0.75rem",
													color: "inherit",
													textAlign: "center",
												}}
											>
												<Spinner animation="border" variant="dark" size="sm" />
											</div>
										</Col>
									</Row>
								</Fragment>
							) : (
								""
							)}
							{produto.length &&
								[...produto]
									.sort((a, b) => {
										if (a.volume > b.volume) return 1;
										if (a.volume < b.volume) return -1;
										return 0;
									})
									.reverse()
									.map((item, key) => {
										return (
											<Fragment key={key}>
												<Row
													className="align-items-center my-1"
													style={{ borderBottom: "solid 1px black" }}
												>
													<Col sm="2">
														{loading ? (
															<div
																style={{
																	fontSize: "0.75rem",
																	color: "inherit",
																}}
															>
																<Spinner
																	animation="border"
																	variant="dark"
																	size="sm"
																/>
															</div>
														) : (
															<p
																style={{
																	fontSize: "0.75rem",
																	color: "inherit",
																	padding: "3px 0px",
																	borderRadius: "4px",
																	marginTop: "5px",
																}}
															>
																<b>{item?.qtde ?? 0}</b>
															</p>
														)}
													</Col>
													<Col sm="6">
														{loading ? (
															<div
																style={{
																	fontSize: "0.75rem",
																	color: "inherit",
																}}
															>
																<Spinner
																	animation="border"
																	variant="dark"
																	size="sm"
																/>
															</div>
														) : (
															<p
																style={{
																	fontSize: "0.75rem",
																	color: "inherit",
																	padding: "3px 0px",
																	borderRadius: "4px",
																	marginTop: "5px",
																}}
															>
																<b>{item?.descricao ?? "Sem Produtos"}</b>
															</p>
														)}
													</Col>
													<Col sm="4">
														{loading ? (
															<div
																style={{
																	fontSize: "0.75rem",
																	color: "inherit",
																	textAlign: "center",
																}}
															>
																<Spinner
																	animation="border"
																	variant="dark"
																	size="sm"
																/>
															</div>
														) : (
															<div className="div-calculator">
																<i
																	className="bi bi-calculator"
																	onClick={(e) =>
																		setShowCalculator({ flag: true, ...item })
																	}
																	hidden={status === 0 ? false : true}
																></i>
																<input
																	placeholder={
																		item.volume >= 0
																			? `${item.volume}`
																			: "Sem Produtos"
																	}
																	onChange={(e) =>
																		changeValue(e, item, "volume")
																	}
																	onBlur={(e) => handleDivBlur(e, item)}
																	value={
																		produtoEditado.qr_sku === item.qr_sku &&
																		produtoEditado?.dimensao == "volume"
																			? produtoEditado.value.new
																			: Number(item.volume).toLocaleString(
																					"pt-BR"
																			  )
																	}
																	// value={
																	//     produtoEditado.qr_sku === item.qr_sku && produtoEditado?.dimensao == 'volume' ?
																	//         (!produtoEditado.value.new ? produtoEditado.value.old
																	//             : produtoEditado.value.new) : Number(item.volume).toLocaleString('pt-BR')
																	// }
																	style={{
																		display: "flex",
																		width: "80px",
																		textAlign: "center",
																		cursor: "pointer",
																	}}
																	disabled={status === 0 ? false : true} // somente possibilitar edição em planejamento
																/>
															</div>
														)}
													</Col>
												</Row>
											</Fragment>
										);
									})}
						</div>
					</Card>
				</Col>
			</Row>
			{editarModal.flag ? (
				<ModalEditarDimensaoProdutosCargas
					title={produtoEditado.title}
					msg={produtoEditado.msg}
					show={editarModal.flag}
					setShow={setEditarModal}
					produtoEditado={editarModal.produtoEditado}
					setProduto={setProdutoEditado}
				/>
			) : (
				""
			)}
			{showCalculator.flag ? (
				<ModalCalculadora
					show={showCalculator.flag}
					setShow={setShowCalculator}
					{...showCalculator}
				/>
			) : (
				""
			)}
			{error.show ? ( <ModalErrorPretty {...error} setShow={setError} />) : ("")}
		</div>
	);
}


function ModalEditarCargaSuporte(props) {
	
	const caminhoes = useSelector((state) => state.userSlice.caminhoesList.data) ?? [];
	let caminhoesFrete = useSelector((state) => state.userSlice.freteiroList.data) ?? [];
	const motoristas = [...props.caminhoesCaminhoneiro.map(c => ({placa: c.caminhao_placa, motorista_cpf: c.cpf_caminhoneiro})), ...caminhoesFrete.map(c => ({placa: c.placa, motorista_cpf: c.motorista_cpf})), ]
	const user = useSelector((state) => state.userSlice);
	const handlerSimpleClose = () => props.setShow((last) => ({ show: false }));

	const [body, setBody] = useState(props.row);
	const [btn, setBtn] = useState({
		flag: false,
		style: "primary",
		msg: "Salvar",
	});
	const [bodyEdit, setBodyEdit] = useState({});
	const [params, setParams] = useState(
		Object.keys(props.row).map((item) => item)
	);

	// Local state for SearchableSelect fields in edit modal
	const [editCaminhaoValue, setEditCaminhaoValue] = useState("");
	const [editStatusValue, setEditStatusValue] = useState("");
	const [editRegiaoEntregaValue, setEditRegiaoEntregaValue] = useState("");
	const [editTipoCargaValue, setEditTipoCargaValue] = useState("");

	const getEditedValue = (params, value) => {
		if (["emissao", "createdAt", "updatedAt"].includes(params))
			return getCorretData(value);
		if (params == "id_filial")
			return (
				user.filiaisList.data.find((item) => item.idFilial == value)
					?.identificacaoInterna || value
			);
		if (params == "romaneio") return String(value).padStart(7, "0");
		if (["peso_total", "metros_quadrados", 'volume_total'].includes(params)) return numerosEditadoBR(value);
		if (params == "valor_total") return valorMoeda(value);
		return value;
	};

	const changeValue = (params, value) => {
		if (params.includes("caminhao")){
			const caminhaoF = motoristas.find(i => i.placa == value)
			
			return setBodyEdit((last) => ({
				...last,
				[params]: value,
				caminhoneiro : cpf_mask(caminhaoF?.motorista_cpf ?? "") 
			}));
		}
		if (params.includes("tel_"))
			return setBodyEdit((last) => ({
				...last,
				[params]: telefoneMask(value),
			}));
		if (["peso_total", "metros_quadrados", 'volume_total'].includes(params))
			return setBodyEdit((last) => ({
				...last,
				[params]: Number(
					numerosDecimal(apenasNumeros(value)).replace(",", ".")
				).toLocaleString("pt-br", { minimumFractionDigits: 2 }),
			}));
		if (params.includes("valor_total"))
			return setBodyEdit((last) => ({
				...last,
				[params]: valorMoeda(
					numerosDecimal(apenasNumeros(value)).replace(",", ".")
				).toLocaleString("pt-br", { minimumFractionDigits: 2 }),
			}));
		setBodyEdit((last) => ({ ...last, [params]: value }));
	};

	const atualizarPedido = async () => {
		if (!bodyEdit) return;
		setBtn({ flag: true, msg: "Carregando", style: "warning" });

		if (bodyEdit.peso_total) {
			bodyEdit.peso_total = bodyEdit.peso_total.replaceAll('.','').replaceAll(',','.')
		}
		if (bodyEdit.valor_total) {
			bodyEdit.valor_total = bodyEdit.valor_total.replaceAll('.','').replaceAll(',','.')
		}
		await props.fnRetorno(
			{ ...bodyEdit, id: body.id },
			body.romaneio
		);
		setBtn({ flag: false, msg: "Salvo", style: "success" });

		setTimeout(() => {
			setBtn({ flag: false, msg: "Salvar", style: "primary" });
			props.setShow(false)
		}, 1000);
	};

	// Initialize edit modal SearchableSelect values
	useEffect(() => {
		setEditCaminhaoValue(body.caminhao || "");
		setEditStatusValue(body.status || "");
		setEditRegiaoEntregaValue(body.regiao_entrega || "");
	}, [body.caminhao, body.status, body.regiao_entrega]);

	// Handlers for SearchableSelect fields in edit modal
	const handleEditCaminhaoChange = (e) => {
		const value = e.target.value;
		setEditCaminhaoValue(value);
		changeValue("caminhao", value);
	};

	const handleEditStatusChange = (e) => {
		const value = e.target.value;
		setEditStatusValue(value);
		setBodyEdit((last) => ({
			...last,
			status: value,
		}));
	};

	const handleEditRegiaoEntregaChange = (e) => {
		const value = e.target.value;
		setEditRegiaoEntregaValue(value);
		setBodyEdit((last) => ({
			...last,
			regiao_entrega: value,
		}));
	};

	const handleEditTipoCargaChange = (e) => {
		const value = e.target.value;
		setEditTipoCargaValue(value);
		setBodyEdit((last) => ({
			...last,
			tipo_carga: value,
		}));
	};

	return (
		<>
			<Modal
				show={props.show}
				onHide={handlerSimpleClose}
				backdrop="static"
				keyboard={false}
				centered
				size="lg"
			>
				<Modal.Header closeButton>
					<Modal.Title>{props.title || "TITULO NÃO INFORMADO"}</Modal.Title>
				</Modal.Header>
				<Modal.Body style={{ overflow: "auto", margin: "0 20px" }}>
					<Form>
						{params
							.map((item) => (
								<Row className="mb-2" key={`key_param_${item}`}>
									<Col sm="3">{item}:</Col>
									<Col>
										{item == "tipo_carga" ? (
											<SearchableSelect
												options={[
													{ value: "PADRÃO", label: "Padrão" },
													{ value: "TRANSFERÊNCIA", label: "Transferência" },
													{ value: "RETORNO", label: "Retorno" }
												]}
												value={editTipoCargaValue}
												onChange={handleEditTipoCargaChange}
												placeholder="Selecione o tipo de carga"
											/>
										) : item == "status" ? (
											<SearchableSelect
												options={getStatusCargaList().map(st => ({
													value: st.status,
													label: `${st.status} - ${st.titulo}`
												}))}
												value={editStatusValue}
												onChange={handleEditStatusChange}
												placeholder="Selecione status..."
												searchPlaceholder="Buscar status..."
												maxHeight="250px"
											/>
										) : item == "caminhao" ? (
											<SearchableSelect
												options={[...caminhoes.map(t => ({...t, origem: "PRÓPRIO"})), ...caminhoesFrete.map(t => ({...t, origem: "FRETE"}))].map(st => ({
													value: st.placa,
													label: `${st.origem} - ${st.placa} - ${st.tipo}`
												}))}
												value={editCaminhaoValue}
												onChange={handleEditCaminhaoChange}
												placeholder="Selecione caminhão..."
												searchPlaceholder="Buscar caminhão..."
												maxHeight="250px"
											/>
										) : item == "regiao_entrega" ? (
											<SearchableSelect
												options={[
													{ value: "LOCAL", label: "Local" },
													{ value: "REGIONAL", label: "Regional" }
												]}
												value={editRegiaoEntregaValue}
												onChange={handleEditRegiaoEntregaChange}
												placeholder="Selecione região..."
												searchPlaceholder="Buscar região..."
												maxHeight="150px"
											/>
										) : (
											<Form.Control
												defaultValue={getEditedValue(item, body[item])}
												value={bodyEdit[item]}
												disabled={[
													"id",
													"id_filial",
												].includes(item)}
												onChange={(e) => changeValue(item, e.target.value)}
											/>
										)}
									</Col>
									<Col sm='3'>
										{ item.includes("data_") ? (
											<Button variant={"dark"} onClick={() => setBodyEdit((last) => ({
												...last,
												[item]: new Date().toISOString(),
											}))}>Agora</Button>
										) : ""
									}
									</Col>
								</Row>
							))}
					</Form>
				</Modal.Body>
				<Modal.Footer className="d-flex flex-row">
					<Button
						variant={btn.style}
						onClick={atualizarPedido}
						style={{ width: "fit-content", paddingInline: "40px" }}
					>
						{btn.msg}
						{btn.style == "success" ? <i className="bi bi-check"></i> : ""}
						{btn.style == "warning" ? (
							<Spinner size="sm" animation="border" color="black" />
						) : (
							""
						)}
					</Button>
					<Button
						variant="secondary"
						onClick={handlerSimpleClose}
						style={{ width: "fit-content", paddingInline: "40px" }}
					>
						Fechar
					</Button>
				</Modal.Footer>
			</Modal>
		</>
	);
}